(() => {
  const instances = new WeakMap();
  const selector = '[data-loox-testimonials]';

  function init(section) {
    if (instances.has(section)) return;
    const rail = section.querySelector('.v31-loox-review-rail');
    if (!rail || section.dataset.autoScroll !== 'true') return;
    const originals = Array.from(rail.children);
    if (!originals.length) return;
    const abort = new AbortController();
    const speed = Math.min(60, Math.max(6, Number(section.dataset.scrollSpeed) || 20));
    let frame = 0;
    let resizeFrame = 0;
    let cycle = 0;
    let position = rail.scrollLeft;
    let lastWritten = position;
    let previousTime = 0;
    let destroyed = false;

    function clearCopies() {
      rail.querySelectorAll('[data-review-copy]').forEach(copy => copy.remove());
    }

    function appendCopy(card) {
      const copy = card.cloneNode(true);
      copy.dataset.reviewCopy = 'true';
      copy.setAttribute('aria-hidden', 'true');
      [copy, ...copy.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id');
        Array.from(element.attributes).forEach(attribute => {
          if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
        });
        if (element.matches('a,button,input,select,textarea,[tabindex]')) element.setAttribute('tabindex', '-1');
      });
      rail.append(copy);
      return copy;
    }

    function rebuild() {
      if (destroyed) return;
      const ratio = cycle ? (position % cycle) / cycle : 0;
      clearCopies();
      const firstCopy = appendCopy(originals[0]);
      cycle = firstCopy.offsetLeft - originals[0].offsetLeft;
      if (cycle <= 0) {
        clearCopies();
        return;
      }
      originals.slice(1).forEach(appendCopy);
      // Additional copies keep the rail filled even with one short review.
      for (let repeat = 1; repeat < Math.ceil(rail.clientWidth / cycle) + 1; repeat += 1) originals.forEach(appendCopy);
      position = ratio * cycle;
      rail.scrollLeft = position;
      lastWritten = rail.scrollLeft;
    }

    function tick(time) {
      if (destroyed) return;
      const elapsed = previousTime ? Math.min((time - previousTime) / 1000, 0.1) : 0;
      previousTime = time;
      if (cycle > 0 && !document.hidden) {
        // Read native touch/keyboard scrolling without rounding away animation progress.
        if (Math.abs(rail.scrollLeft - lastWritten) > 1) position = rail.scrollLeft;
        position = ((position + speed * elapsed) % cycle + cycle) % cycle;
        rail.scrollLeft = position;
        lastWritten = rail.scrollLeft;
      }
      frame = requestAnimationFrame(tick);
    }

    const resizeObserver = new ResizeObserver(() => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(rebuild);
    });
    resizeObserver.observe(rail);
    document.addEventListener('visibilitychange', () => { previousTime = 0; }, { signal: abort.signal });
    section.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('.v31-loox-review-card');
      if (!card || !originals.includes(card)) return;
      position = card.offsetLeft - originals[0].offsetLeft;
      rail.scrollLeft = position;
      lastWritten = rail.scrollLeft;
    }, { signal: abort.signal });

    instances.set(section, () => {
      destroyed = true;
      cancelAnimationFrame(frame);
      cancelAnimationFrame(resizeFrame);
      resizeObserver.disconnect();
      abort.abort();
      clearCopies();
      instances.delete(section);
    });
    rebuild();
    // The merchant explicitly enables continuous motion, including hover/focus/reduced motion.
    frame = requestAnimationFrame(tick);
  }

  function mount(root) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.(selector)) instances.get(event.target)?.();
    event.target.querySelectorAll(selector).forEach(section => instances.get(section)?.());
  });
})();
